/**
 * Site-wide fix for an Upload Kit bug (confirmed via stack trace — the call
 * originates entirely inside jquery.min.js -> uploadcare-uploadkit's own
 * bundle, none of this theme's code): when a customer uploads a file Upload
 * Kit can't generate a crop/thumbnail UI for (its own console warns "Cropper
 * observer is not active" — happens for PSD/PDF/EPS and any other type it
 * doesn't recognize as a croppable image), it still calls window.scrollTo
 * trying to bring that UI into view, landing on the wrong part of the page.
 * Affects every product using Upload Kit, not just TPU Premium Hat Patches,
 * so this is loaded unconditionally rather than gated to one product.
 *
 * Suppresses window.scrollTo / scrollBy / Element.scrollIntoView only for a
 * short window after Upload Kit's own "unrecognized file" card
 * (.uploadkit-file-listing) appears — not globally, so normal scrolling and
 * Upload Kit's own crop flow for recognized images are unaffected. Pages
 * with a more precise start/end signal (e.g. tpu-file-preview.js, which
 * knows exactly when its own conversion pipeline finishes) can call
 * window.uploadkitSuppressScroll(true/false) directly for a tighter window
 * instead of relying on the timeout fallback below.
 */
(function () {
  var suppressed = false;
  var clearTimer = null;
  var FALLBACK_MS = 3000; // generous — the real scrollTo fires within ~1s of upload

  window.uploadkitSuppressScroll = function (on) {
    suppressed = !!on;
    if (clearTimer) { clearTimeout(clearTimer); clearTimer = null; }
  };

  ['scrollTo', 'scrollBy'].forEach(function (name) {
    var original = window[name];
    window[name] = function () {
      if (suppressed) return;
      return original.apply(this, arguments);
    };
  });
  var originalScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function () {
    if (suppressed) return;
    return originalScrollIntoView.apply(this, arguments);
  };

  function onUnrecognizedFile(listing) {
    if (listing.dataset.uploadkitScrollGuarded) return;
    listing.dataset.uploadkitScrollGuarded = 'true';
    if (listing.querySelector('.uploadkit-thumbnail')) return; // recognized image, not our case

    window.uploadkitSuppressScroll(true);
    clearTimer = setTimeout(function () {
      window.uploadkitSuppressScroll(false);
    }, FALLBACK_MS);
  }

  var observer = new MutationObserver(function () {
    document.querySelectorAll('.uploadkit-file-listing').forEach(onUnrecognizedFile);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
